import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M21.98 7.01c-.087 1.948-1.45 4.619-4.078 8.007-2.723 3.539-5.021 5.308-6.908 5.308-1.175 0-2.148-1.078-2.96-3.234l-1.598-5.929q-.898-3.23-1.927-3.231-.225 0-1.567.943L2 7.66q1.47-1.292 2.919-2.606c1.315-1.14 2.303-1.737 2.96-1.8q2.334-.225 2.873 3.2.581 3.69.808 4.588.676 3.063 1.48 3.062.629 0 1.888-1.988 1.255-1.985 1.344-3.023c.12-1.142-.33-1.717-1.345-1.717-.479 0-.973.1-1.481.325.987-3.222 2.861-4.797 5.635-4.697 2.06.05 3.023 1.387 2.91 3.998z"
    }, null, -1)
  ]))]))
}
export default { render: render }